jQuery('.woocommerce__clear-cart-btn').click(function(e){
  let ele = jQuery(this);
  if (!confirm('Haluatko varmasti tyhjentää ostoskorin?')) {
    e.preventDefault();
  }
});

function cartEditKaiverrus(pid) {
  jQuery('#kaiverrus-' + pid).addClass('open');
}

function cartClosePopup(pid) {
  jQuery('#kaiverrus-' + pid).removeClass('open');
}

function cartSaveRows(pid) {
  cartSaveAllRows(pid);
  cartClosePopup(pid);
}

function cartSaveAllRows(pid) {
  let tuote = '';
  jQuery('#kaiverrus-' + pid + ' .kaiverrus__tuote-container').each(function(){
    jQuery(this).find('.kaiverrus__rivi').each(function(){
      if ( jQuery(this).val() != '') {
        tuote += jQuery(this).val();
        tuote += '<br>';
      }
    });
    tuote = tuote.slice(0, -4);
  });
  jQuery.ajax({
    type: "post",
    dataType: "json",
    url: wpSettings.ajax_url,
    data: { action: "updateCartKaiverrus", kaiverrus: tuote, pid: pid },
    success: function(msg){
        console.log(msg);
    }
  });
}

function cartUpdateRow(ele, pid){
  let rivilen = jQuery(ele).val().length;
  if ( rivilen >= jQuery(ele).attr('maxlength') ) {
    jQuery(ele).addClass('full');
  } else {
    if ( jQuery(ele).hasClass('full') ) {
      jQuery(ele).removeClass('full');
    }
  }
  jQuery(ele).next('.kaiverrus__rivi-count').html(rivilen);
  cartUpdateRowPrice(pid);
}

function cartUpdateRowPrice(pid) {
  let price = cartGetRowPrice(pid);
  jQuery('#kaiverrus-' + pid + ' .kaiverrushinta').html( price + ' merkkiä');
  jQuery('#kaiverrushinta-' + pid).html( price );

  //let totalPrice = price + parseFloat( jQuery('#kaiverrus-tuotepohjahinta').attr('data-hinta') );
  //totalPrice = Math.round((totalPrice + Number.EPSILON) * 100) / 100;
  //jQuery('#hinta-' + pid).html( totalPrice );

  //let subTotal = totalPrice * parseInt( jQuery('#hinta-' + pid).parent().next().find('input').val() );
  //subTotal = Math.round((subTotal + Number.EPSILON) * 100) / 100;
  //jQuery('#subtotal-' + pid).html( subTotal );
}

function cartGetRowPrice(pid) {
  let price = 0;
  //let kirjainhinta = parseFloat( jQuery('#kaiverrus-' + pid + ' .kaiverrushinta').attr('data-kirjainhinta') );

  jQuery('#kaiverrus-' + pid + ' .kaiverrus__rivi').each(function(){
    let rowlen = jQuery(this).val().split(' ').join('').length;
    //let rowprice = rowlen * kirjainhinta;
    let rowprice = rowlen;
    price = price + rowprice;
  });
  //return Math.round((price + Number.EPSILON) * 100) / 100;
  return price;
}